import { IconWrapper } from '../runtime';
export default IconWrapper('whiteboard-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + '306a5e5b' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.3879 6.93205L7.96703 13.3529L7.97955 16.7876L11.4142 16.8001L17.8351 10.3792L14.3879 6.93205ZM15.1834 4.54557C14.7441 4.10623 14.0318 4.10623 13.5924 4.54557L6.04484 12.0932C5.83285 12.3051 5.71425 12.593 5.71534 12.8927C5.72143 14.5637 5.73158 16.2348 5.7351 17.9058C5.73641 18.5271 6.24003 19.0307 6.86135 19.032C8.53235 19.0355 10.2034 19.0457 11.8744 19.0518C12.1742 19.0529 12.462 18.9343 12.674 18.7223L20.2215 11.1747C20.6609 10.7354 20.6609 10.023 20.2215 9.58371L15.1834 4.54557Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.43311 14.0358L14.4284 9.04052L15.7542 10.3663L10.8705 15.25L9.45987 15.2411L9.43311 14.0358Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '306a5e5b',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#6E788A"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#3E4B61"
    }
  })])])]);
});